import { z } from "zod";
import { userResponseSchema } from "./user.schema";

export const requestCodeSchema = z.object({
  telefone: z
    .string()
    .regex(/^\d{10,11}$/, "Telefone deve ter 10 ou 11 dígitos"),
});

export const phoneLoginSchema = z.object({
  telefone: z
    .string()
    .regex(/^\d{10,11}$/, "Telefone deve ter 10 ou 11 dígitos"),
  codigo: z.string().regex(/^\d{6}$/, "Código deve ter 6 dígitos"),
});

export const emailLoginSchema = z.object({
  email: z.string().email("E-mail inválido"),
});

export const googleLoginSchema = z.object({
  idToken: z.string().min(1, "Token do Google é obrigatório"),
});

export const messageResponseSchema = z.object({
  message: z.string(),
});

export const authResponseSchema = z.object({
  access: z.string().optional(),
  user: userResponseSchema,
  requiresPhoneVerification: z.boolean().optional(),
  requiresEmailVerification: z.boolean().optional(),
});

export const verifyPhoneSchema = z.object({
  telefone: z
    .string()
    .regex(/^\d{10,11}$/, "Telefone deve ter 10 ou 11 dígitos"),
  codigo: z.string().regex(/^\d{6}$/, "Código deve ter 6 dígitos"),
});

export const verifyPhoneResponseSchema = z.union([
  authResponseSchema,
  z.object({
    verified: z.boolean(),
  }),
]);

export const tokenVerificationResponseSchema = z.object({
  valid: z.boolean(),
});

export type RequestCodeDto = z.infer<typeof requestCodeSchema>;
export type PhoneLoginDto = z.infer<typeof phoneLoginSchema>;
export type EmailLoginDto = z.infer<typeof emailLoginSchema>;
export type GoogleLoginDto = z.infer<typeof googleLoginSchema>;
export type MessageResponseDto = z.infer<typeof messageResponseSchema>;
export type AuthResponseDto = z.infer<typeof authResponseSchema>;
export type TokenVerificationResponseDto = z.infer<
  typeof tokenVerificationResponseSchema
>;
export type VerifyPhoneDto = z.infer<typeof verifyPhoneSchema>;
export type VerifyPhoneResponseDto = z.infer<typeof verifyPhoneResponseSchema>;
